import { useCallback } from "react";
import { useGroups } from "../../features/Settings/General/OrganisationLevelGroups/context"
import { renderSettingsResourceLabel } from "../helpers/settings";

export const useOrgSettingsResourceLabel = () => {
    const { groups } = useGroups();

    return useCallback((value) => {
        if (!value) return null;

        const display = groups?.find(
            (group) => group.id === (value?.orgLevelGroup?.id ?? value?.orgLevelGroup)
        )?.display ?? "code-description";

        switch (display) {
            default:
            case "code-description": {
                return renderSettingsResourceLabel(value);
            }
            case "code": {
                return value.code;
            }
            case "description": {
                return value.description;
            }
            case "gl-segment": {
                return value?.glSegment ?? value?.description;
            }
            case "glSegment-description": {
                return value?.glSegment
                    ? `${value.glSegment}-${value.description}`
                    : value.description;
            }
        }
    }, [groups]);
}
